<template>
  <div class="container">
    <h3>完善个人信息</h3>
    <main class="improve">
      <a-form-model ref="updateRuleForm" :model="updateForm" :rules="updateRules" :label-col="{ span: 6 }"
        :wrapper-col="{ span: 14 }">
        <a-form-model-item label="姓名" prop="userName">
          <a-input v-model="updateForm.userName" size="large" placeholder="请输入" />
        </a-form-model-item>

        <a-form-model-item label="证件类型" prop="certificateType">
          <a-select v-model="updateForm.certificateType" size="large" placeholder="请选择">
            <a-select-option value="0">身份证号</a-select-option>
            <a-select-option value="1">护照</a-select-option>
            <a-select-option value="8">港澳台通行证</a-select-option>
            <a-select-option value="2">其他</a-select-option>

          </a-select>
        </a-form-model-item>

        <a-form-model-item v-if="updateForm.certificateType == '0'" label="身份证号" prop="idCard">
          <a-input v-model="updateForm.idCard" :maxLength="18" size="large" placeholder="请输入" />
        </a-form-model-item>

        <a-form-model-item v-else label="证件号" prop="passport">
          <a-input v-model="updateForm.passport" size="large" placeholder="请输入" />
        </a-form-model-item>

        <a-form-model-item label="手机号" prop="phone">
          <a-input v-model="updateForm.phone" :maxLength="11" placeholder="请输入" size="large" :disabled="isDisable" />
        </a-form-model-item>

        <a-form-model-item label="验证码" prop="code" v-if="!isDisable">
          <a-row :gutter="8">
            <a-col :span="8">
              <a-input v-model="updateForm.code" :maxLength="6" placeholder="请输入" size="large" />
            </a-col>
            <a-col :span="5">
              <a-button :disabled="isStart" @click="getCodeFn" size="large">
                获取{{ isStart ? "(" + second + ")" : "" }}
              </a-button>
            </a-col>
          </a-row>
        </a-form-model-item>

        <a-form-model-item label="性别" prop="gender">
          <a-select v-model="updateForm.gender" size="large" placeholder="请选择">
            <a-select-option value="1">男</a-select-option>
            <a-select-option value="2">女</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="出生日期" prop="birthday">
          <a-date-picker v-model="updateForm.birthday" valueFormat="YYYY-MM-DD" format="YYYY-MM-DD" size="large" />
        </a-form-model-item>

        <a-form-model-item label="所属单位" prop="unit">
          <a-select v-model="updateForm.unit" size="large" placeholder="请选择">
            <a-select-option value="浙江大学">浙江大学</a-select-option>
            <a-select-option value="其他">其他</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item v-if="updateForm.unit == '其他'" label="其他单位" prop="otherUnit">
          <a-input v-model="updateForm.otherUnit" size="large" placeholder="请输入" />
        </a-form-model-item>

        <a-form-model-item v-if="updateForm.unit.toString().includes('浙江大学')" label="学院部门" prop="dept">
          <a-input v-model="updateForm.dept" size="large" placeholder="请输入" />
        </a-form-model-item>

        <a-form-model-item label="人员类型" prop="userType">
          <a-select v-model="updateForm.userType" size="large" placeholder="请选择">
            <a-select-option v-for="item in userTypeOptions" :key="item.value" :value="item.value">{{ item.label
            }}</a-select-option>
          </a-select>
        </a-form-model-item>

        <!--校外人员填写人员职称-->
        <!-- <a-form-model-item
          v-if="updateForm.userType == 4"
          label="人员职称"
          prop="title"
        >
          <a-input
            v-model="updateForm.title"
            size="large"
            placeholder="请输入"
          />
        </a-form-model-item> -->

        <!--在职、在校学生填写-->
        <a-form-model-item v-if="updateForm.userType == 1 || updateForm.userType == 2" label="所属校区" prop="college">
          <a-select v-model="updateForm.college" size="large" placeholder="请选择">
            <a-select-option v-for="(item, index) in collegeOptions" :key="index" :value="item.label">{{ item.label
            }}</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="邮箱地址" prop="email">
          <a-input v-model="updateForm.email" size="large" placeholder="请输入" />
        </a-form-model-item>

        <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
          <a-button type="primary" @click="onSubmit" :loading="confirmLoading" :disabled="confirmLoading">
            保存
          </a-button>
          <a-button style="margin-left: 10px" @click="resetForm">
            重置
          </a-button>
        </a-form-model-item>
      </a-form-model>
    </main>
  </div>
</template>
<script>
import { updateUserInfo } from "@/api/bac";
import { getCode, userLogin } from "@/api/login";
import base from "@/assets/base/base.js";
export default {
  data() {
    return {
      updateForm: {
        gender: "1",
        certificateType: "0",
        userType: "5",
        idCard: "",
        birthday: "",
        phone: "",
        code: "",
        college: "",
        jobNo: "",
        passport: "", //护照
        userName: "",
        unit: "", //单位
        otherUnit: "", //其他单位
        dept: "", //部门
        title: "", //职称
        email: "", //邮箱
      },
      updateRules: {
        userName: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          },
        ],
        certificateType: [
          {
            required: true,
            message: "请选择证件类型",
            trigger: "change",
          },
        ],
        idCard: [
          {
            required: true,
            message: "请输入身份证号",
            trigger: "blur",
          },
          {
            pattern:
              /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
            message: "请输入正确的身份证号",
            trigger: "change",
          },
        ],
        passport: [
          {
            required: true,
            message: "请输入证件号",
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
          {
            pattern:
              /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
            message: "请输入正确的手机号",
            trigger: "change",
          },
        ],
        code: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur",
          },
        ],
        gender: [
          {
            required: true,
            message: "请选择性别",
            trigger: "change",
          },
        ],
        birthday: [
          {
            required: true,
            message: "请选择出生日期",
            trigger: "change",
          },
        ],
        unit: [
          {
            required: true,
            message: "请选择所属单位",
            trigger: "change",
          },
        ],
        otherUnit: [
          {
            required: true,
            message: "请输入其他单位",
            trigger: "blur",
          },
        ],
        dept: [
          {
            required: true,
            message: "请输入部门",
            trigger: "blur",
          },
        ],
        title: [
          {
            required: true,
            message: "请选择职称",
            trigger: "change",
          },
        ],
        userType: [
          {
            required: true,
            message: "请选择人员类型",
            trigger: "change",
          },
        ],
        college: [
          {
            required: true,
            message: "请选择校区",
            trigger: "change",
          },
        ],
        email: [
          {
            required: false,
            message: "请输入邮箱",
            trigger: "blur",
          },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: "blur",
          },
        ],
      },
      userTypeOptions: [
        {
          label: "在职",
          value: "1",
        },
        {
          label: "在校学生",
          value: "2",
        },
        {
          label: "退休",
          value: "3",
        },
        {
          label: "校外人员",
          value: "4",
        },
        {
          label: "其他",
          value: "5",
        },
      ],
      collegeOptions: [
        {
          label: "紫金港校区",
        },
        {
          label: "玉泉校区",
        },
        {
          label: "华家池校区",
        },
        {
          label: "西溪校区",
        },
      ],
      confirmLoading: false,
      isStart: false,
      second: 60,
      isDisable: false,
    };
  },
  methods: {
    onSubmit() {
      this.$refs.updateRuleForm.validate((valid) => {
        if (valid) {
          this.updateUserInfo();
        } else {
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.updateRuleForm.resetFields();
    },
    //获取验证码
    async getCodeFn() {
      if (!base.isPoneAvailable(this.updateForm.phone)) {
        this.$message.warning("请输入正确的手机号");
        return;
      }
      const { code, msg } = await getCode(this.updateForm.phone);
      if (code == 200) {
        this.$message.success(msg);
        this.startTime();
      }
    },

    /**倒计时*/
    startTime() {
      this.second = 60;
      this.isStart = true;
      this.setTime = setInterval(() => {
        if (this.second > 1) {
          this.second--;
        } else {
          clearInterval(this.setTime);
          this.isStart = false;
        }
      }, 1 * 1000);
    },

    /**修改个人信息接口 */
    async updateUserInfo() {
      this.confirmLoading = true;
      /**
       * 修改类型 1-完善信息 2-修改信息
       * private Integer updateType;
       */

      /**
       * 手机验证码
       * private String code;
       */

      const params = {
        ...this.updateForm,
        updateType: this.isDisable ? 2 : 1,
        unit:
          this.updateForm.unit == "其他"
            ? this.updateForm.otherUnit
            : this.updateForm.unit,
        encrVa: base.encryptAES(this.updateForm.userName + this.updateForm.phone + this.updateForm.userNo),//加密字段
      };

      setTimeout(() => {
        this.confirmLoading = false;
      }, 2000);

      const { code, data } = await updateUserInfo(params);

      if (code == 200) {
        this.$message.success("保存成功");
        sessionStorage.setItem("token", data.token);
        sessionStorage.setItem("userInfo", JSON.stringify(data.e));
        this.$store.commit("login/changLogin", true);
        // 检查是否有保存的重定向路径
        const redirectUrl = sessionStorage.getItem("redirectUrl");
        if (redirectUrl) {
          sessionStorage.removeItem("redirectUrl");
          this.$router.replace(redirectUrl);
        } else {
          this.$router.replace("/index");
        }

      }
    },
  },
  created() {
    this.updateForm = JSON.parse(sessionStorage.getItem("userInfo")) || {};

    //有手机号时禁用修改手机号
    if (this.updateForm.phone) {
      this.isDisable = true;
    } else {
      this.isDisable = false;
    }

    try {
      let otherUnit =
        this.updateForm.unit == "浙江大学" ? "" : this.updateForm.unit;

      let unit =
        this.updateForm.unit == "浙江大学" ? this.updateForm.unit : "其他";

      this.$set(this.updateForm, "otherUnit", otherUnit);

      this.$set(this.updateForm, "unit", unit);

      this.confirmLoading = false;
    } catch (error) { }
  },
};
</script>
<style scoped>
h3 {
  font-size: 16px;
  font-weight: bold;
  text-align: center;
}

main {
  margin-top: 20px;
}
</style>